const TOPICS = [
  { label: '港片经典', hot: true },
  { label: '悬疑推理', hot: true },
  { label: '科幻大片', hot: false },
  { label: '国产剧集', hot: true },
  { label: '热血动漫', hot: true },
  { label: '4K蓝光', hot: false },
  { label: '纪录片', hot: false },
  { label: '高分神作', hot: true },
  { label: '新片速递', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热门话题</h2>
            <p className="mt-2 text-sm text-foreground-500">大家都在搜的热门标签，发现更多精彩内容</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
            {TOPICS.map((topic, i) => (
              <a
                key={i}
                href="#cards"
                className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                  topic.hot
                    ? 'bg-accent-100 text-accent-700 hover:bg-accent-200 border border-accent-200/60'
                    : 'bg-background-200 text-foreground-600 hover:bg-background-300 border border-background-300/60'
                }`}
              >
                {topic.label}
                {topic.hot && (
                  <span className="flex items-center">
                    <i className="ri-fire-line text-xs text-accent-500"></i>
                  </span>
                )}
              </a>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-6 text-xs text-foreground-400">
            <span>本周热搜：港片经典</span>
            <span className="hidden sm:inline">·</span>
            <span>新上线：12 个专题</span>
            <span className="hidden sm:inline">·</span>
            <span>活跃话题：28 个</span>
          </div>
        </div>
      </div>
    </section>
  );
}